export default __webpack_public_path__ + "static/media/full_sangam.7a0935cf.png";